export default __webpack_public_path__ + "static/media/ShapeFlag.01af4335.svg";